





































import Vue from 'vue'
import Component from 'vue-class-component'
import Accordion from '@/components/Accordion.vue'
import CircleChart from '@/components/chart/CircleChart.vue'
import Tabs from '@/components/layout/Tabs.vue'
import { ITabsItem } from '@/interfaces'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import { EUserPermissions } from '@zunta/configurations'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import AddHMOModal from './components/AddHMOModal.vue'
import AddHMOPaymentModal from './components/AddHMOPaymentModal.vue'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Icon,
    Accordion,
    CircleChart,
    Tabs,
    AddHMOModal,
    AddHMOPaymentModal
  }
})
export default class Payments extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User

  showAddHMOModal: boolean = false
  showAddHMOPaymentModal: boolean = false
  reopenAddHMOPaymentModal: boolean = false
  isLoadingReport: boolean = false;

  get query () {
    return this.$route.query
  }

  get autoPayItems () {
    return this.$store.state.payments.autoPayItems
  }

  get tabsListItems () {
    const items: ITabsItem[] = []
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_AUTOPAY)) {
      items.push({
        key: 'needs-review',
        value: { name: 'management-payments-sections-needs-review' },
        content: 'Auto Payments'
      })
    }

    items.push({
      key: 'processed',
      value: { name: 'management-payments-sections-processed' },
      content: 'Payment History'
    })

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_DEPOSITS)) {
      items.push({
        key: 'deposits',
        value: { name: 'management-payments-sections-deposits' },
        content: 'Deposits'
      })
    }
    return items
  }

  // async downloadReport (type: string) {
  //   this.isLoadingReport = true
  //   await this.paymentsModuleInstance.downloadPaymentsListReport()
  //   this.isLoadingReport = false
  // }

  mounted () {
    this.$locationManager.rememberLocation(this.$route.fullPath)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    if (to.name === 'management-payments-sections-needs-review' && !this.user.hasPermissionFor(EUserPermissions.VIEW_AUTOPAY)) {
      next({ name: 'management-payments-sections-processed' })
      return
    }
    next()
  }

  // beforeRouteUpdate () {
  //   console.log('update')
  // }

  openAddHMOModal () {
    this.showAddHMOPaymentModal = false
    this.showAddHMOModal = true
    this.reopenAddHMOPaymentModal = true
  }

  openHMOPaymentModal () {
    this.showAddHMOPaymentModal = true
  }

  closeAddHMO () {
    this.showAddHMOModal = false
    if (this.reopenAddHMOPaymentModal) {
      this.showAddHMOPaymentModal = true
    }
    this.reopenAddHMOPaymentModal = false
  }
}
